import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { JOURNAL } from '../../config/site';
import { SectionHeader } from '../common';

function Bars() {
  const data = [40, 62, 48, 75, 58, 84, 70, 92, 66, 78];
  return (
    <div className="flex items-end gap-1.5 h-24">
      {data.map((d, i) => <div key={i} className="flex-1 rounded-t" style={{ height: `${d}%`, background: i % 3 === 0 ? 'var(--gold-grad)' : 'var(--surface-3)' }} />)}
    </div>
  );
}

export default function TradeJournalSection() {
  const toneColor = { up: 'var(--emerald)', down: 'var(--down)', gold: 'var(--gold-2)', default: 'var(--white)' };
  return (
    <section className="section" style={{ background: 'var(--bg-2)', borderTop: '1px solid var(--border)', borderBottom: '1px solid var(--border)' }}>
      <div className="container-x">
        <div className="reveal"><SectionHeader eyebrow="Trade Journal" title="Every trade leaves a trail." sub="An analytics dashboard that turns your activity into insight — so discipline compounds over time." /></div>
        <div className="grid lg:grid-cols-3 gap-5 mt-14">
          <div className="lg:col-span-2 panel p-6 reveal">
            <div className="grid grid-cols-2 sm:grid-cols-3 gap-4">
              {JOURNAL.map((j) => (
                <div key={j.label} className="panel-2 p-4">
                  <div className="font-mono text-[10px] text-[var(--muted-2)] tracking-wide">{j.label.toUpperCase()}</div>
                  <div className="font-display text-[22px] font-bold mt-1" style={{ color: toneColor[j.tone] }}>{j.value}</div>
                </div>
              ))}
            </div>
            <div className="mt-6 panel-2 p-5">
              <div className="font-mono text-[11px] text-[var(--muted-2)] mb-3">DAILY PERFORMANCE</div>
              <Bars />
            </div>
          </div>
          <div className="panel p-6 reveal flex flex-col justify-between">
            <div>
              <h3 className="font-display text-[18px] font-bold text-white">Know your edge</h3>
              <ul className="mt-4 flex flex-col gap-3 text-[14px] text-[var(--muted)]">
                {['Strategy performance', 'Asset performance', 'Execution history', 'Drawdown & risk trends'].map((t) => <li key={t} className="flex items-center gap-2.5"><span className="w-1.5 h-1.5 rounded-full" style={{ background: 'var(--gold-2)' }} />{t}</li>)}
              </ul>
            </div>
            <Link to="/trade-journal" className="btn-gold inline-flex items-center justify-center gap-2 rounded-xl h-11 px-6 text-[14px] font-semibold mt-6">View Trade Journal <ArrowRight size={15} /></Link>
          </div>
        </div>
      </div>
    </section>
  );
}
